import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'ListItemLabel',
    breadcrumbName: 'ListItemLabel',
  },
];

const ListItemLabel = () => {
  return (
    <>

      <PageHeader title="ListItem-label" breadcrumb={{ routes }} subTitle="ListItem-label-icons" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="list_item_wrapper">
          <div className="list_item"><span className="icon_lt redorange_lv5">HOT</span></div>
          <div className="list_item"><span className="icon_lt green_lv5">HOT</span></div>
          <div className="list_item"><span className="icon_lt blue_lv5">HOT</span></div>
          <div className="list_item"><span className="icon_lt graycyan_lv5">HOT</span></div>
          <div className="list_item"><span className="icon_rb redorange_lv5">GO</span></div>
          <div className="list_item"><span className="icon_rb green_lv5">GO</span></div>
          <div className="list_item"><span className="icon_rb blue_lv5">GO</span></div>
          <div className="list_item"><span className="icon_rb graycyan_lv5">GO</span></div>
          <div className="list_item"><span className="icon_rt redorange_lv5">NEW</span></div>
          <div className="list_item"><span className="icon_rt green_lv5">HOT</span></div>
          <div className="list_item"><span className="icon_rt blue_lv5">5%</span></div>
          <div className="list_item"><span className="icon_rt graycyan_lv5">10%</span></div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="list_item_wrapper">
  <div class="list_item"><span class="icon_lt redorange_lv5">HOT</span></div>
  <div class="list_item"><span class="icon_lt green_lv5">HOT</span></div>
  <div class="list_item"><span class="icon_lt blue_lv5">HOT</span></div>
  <div class="list_item"><span class="icon_lt graycyan_lv5">HOT</span></div>
  <div class="list_item"><span class="icon_rb redorange_lv5">GO</span></div>
  <div class="list_item"><span class="icon_rb green_lv5">GO</span></div>
  <div class="list_item"><span class="icon_rb blue_lv5">GO</span></div>
  <div class="list_item"><span class="icon_rb graycyan_lv5">GO</span></div>
  <div class="list_item"><span class="icon_rt redorange_lv5">NEW</span></div>
  <div class="list_item"><span class="icon_rt green_lv5">HOT</span></div>
  <div class="list_item"><span class="icon_rt blue_lv5">5%</span></div>
  <div class="list_item"><span class="icon_rt graycyan_lv5">10%</span></div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default ListItemLabel;
